/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HoodieInputs */

const en_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoodie`)
};

const es_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudadera con capucha`)
};

const fr_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sweat à capuche`)
};

const de_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapuzenpullover`)
};

const ja_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーカー`)
};

const zh_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卫衣`)
};

const ar_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هودي`)
};

const id_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoodie`)
};

const it_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felpa con Cappuccio`)
};

const ru_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Худи / Толстовка`)
};

const pt_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moletom com Capuz`)
};

const ko_val_hoodie = /** @type {(inputs: Val_HoodieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`후디`)
};

/**
* | output |
* | --- |
* | "Hoodie" |
*
* @param {Val_HoodieInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_hoodie = /** @type {((inputs?: Val_HoodieInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HoodieInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_hoodie(inputs)
	if (locale === "es") return es_val_hoodie(inputs)
	if (locale === "fr") return fr_val_hoodie(inputs)
	if (locale === "de") return de_val_hoodie(inputs)
	if (locale === "ja") return ja_val_hoodie(inputs)
	if (locale === "zh") return zh_val_hoodie(inputs)
	if (locale === "ar") return ar_val_hoodie(inputs)
	if (locale === "id") return id_val_hoodie(inputs)
	if (locale === "it") return it_val_hoodie(inputs)
	if (locale === "ru") return ru_val_hoodie(inputs)
	if (locale === "pt") return pt_val_hoodie(inputs)
	return ko_val_hoodie(inputs)
});